module.exports = __webpack_public_path__ + "static/media/split.b7416fed.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/split.png
// module id = 835
// module chunks = 0